import React from "react";

import "../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import InfiniteScroll from 'react-infinite-scroller';
import CircularProgress from '@mui/material/CircularProgress';
import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import * as Constants from "../../../consts/Constants.js";

import alerter from "../../alerts/alerter";
import ErrorView from "./error-details"
import ErrorItem from "./error-item"
import Filters from "./filters";
import Pager from "../../utils/pager";
import service from '../../../plas/errors/service';

function Errors({ history }) {

  let { path, url } = useRouteMatch();
  const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

  const pager = React.useRef(new Pager(5));

  const [filters, setFilters] = React.useState({});
  const [items, setItems] = React.useState([]);
  const [moreItems, setMoreItems] = React.useState(true);
  
  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 16,
          height: 2
        }}
      />
  );

  const open = (rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  const close = () => {
    history.goBack()
  }

  const getNextPage = () => {
    let page = pager.current.getNextPage();
    let order = ["-time"];

    let startDate = filters.date;
    let endDate = null;
    if (startDate)
      endDate = startDate + 86400000;


    service.api.getPage(page.startItem,page.endItem,null,filters.category,filters.operation,startDate,endDate,order,(response) => {
      if (response.result != null) {
        pager.current.update(response.result.data.length, response.result.total)
        setMoreItems(!pager.current.ended);
        setItems([...items, ...response.result.data]);
      } else {
        alerter.showError(response.error);
        setMoreItems(false);
      }
    });
  }

  const filterChange = (options) => {
    setFilters(options);
    resetSearch();
  }

  const resetSearch = () => {
    pager.current.reset();
    setItems([]);
    setMoreItems(true);
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={false} md={2} />
        <Grid item xs={12} md={8} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <p style={{ fontSize: '28px', textAlign: 'left'}}>
                    Errores
                  </p>
                </Grid>
              </Grid>
              <ColoredLine color="gray" marginTop={0} marginBottom={0} />
            </Grid>
            <Grid item xs={12}>
              <Filters onChange={filterChange}/>
            </Grid>
            <Grid item xs={12}>
              <div >
                <InfiniteScroll
                  pageStart={0}
                  loadMore={getNextPage}
                  hasMore={moreItems}
                  loader={<CircularProgress key={-1} size={32} style={{color:Constants.COLOR_PRIMARY, padding: 2}} color="inherit" />}>
                  {items.map((item, index) =>( 
                    <Grid key={item.id} container spacing={2}>
                      <Grid item xs={true}>
                        <ErrorItem error={item} onOpen={open} />
                      </Grid>
                    </Grid>
                  ))}
                </InfiniteScroll>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={false} md={2} />
      </Grid>
      <Switch>
        <Route exact path={path}>
        </Route>
        <Route exact path={`${path}/:errorId`}
          render={ (props) => 
            <Dialog
              maxWidth="lg" 
              onClose={close}
              fullScreen={isMedium}
              open={true}
              fullWidth={true}>
              <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
                <ErrorView close={close} fullWidth={true} errorId={props.match.params.errorId}/>
              </DialogContent>
            </Dialog>
          }
        />
      </Switch>
    </div>
  );

}

export default withRouter(Errors);
